import styled from 'styled-components';

export const FormItemShimmer = styled.div`
  background-color: #f7f7f7;
  border-radius: 2px;
  height: 20px;
  width: 100%;
`;

export const AlertContainer = styled.div`
  border: 1px solid #ee4a49;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const DepositButton = styled.button`
  padding: 6px 20px;
  border-radius: 4px;
  background-color: #ebf8f3;
  outline: none;
  border: none;
  color: #00ab6b;
  font-size: 12px;
  text-align: center;
  font-weight: 700;
`;
